/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterB = createReactComponent("outline", "letter-b", "IconLetterB", [["path", { "d": "M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6", "key": "svg-0" }], ["path", { "d": "M7 12l6 0", "key": "svg-1" }]]);

export { IconLetterB as default };
//# sourceMappingURL=IconLetterB.mjs.map
